export const PAGE_REQUEST = "PAGE_REQUEST";
export const PAGE_UPDATED = "PAGE_UPDATED";
export const PAGE_DELETE = "PAGE_DELETE";
export const PAGE_CU = "PAGE_CU";
export const PAGE_SUCCESS = "PAGE_SUCCESS";
export const PAGE_ERROR = "PAGE_ERROR";
export const PAGE_LOADED = "PAGE_LOADED";
